import {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import {noop, reduce, keys} from 'lodash/fp';
import {Modal as AntModal} from 'antd';
import {IconSuccessCircleO, IconCloseCircleO, IconInfoCircleO, IconFailCircleO} from '@baidu/ee-icon/svg';
import Button from '../Button';
import styles from './index.less';

const infoTypeMap = {
    info: [IconInfoCircleO, '提示'],
    warning: [IconFailCircleO, '警告'],
    error: [IconCloseCircleO, '失败'],
    success: [IconSuccessCircleO, '成功']
};
const modalSizeMap = {
    s: [400, 'size-s'],
    m: [600, 'size-m'],
    l: [800, 'size-l'],
    xl: [960, 'size-xl']
};
const maskStyle = {backgroundColor: 'rgba(0, 0, 0, 0.6)'};

const cx = classNames.bind(styles);

class Modal extends PureComponent {
    handleCancel = () => this.props.onCancel();

    handleOk = () => this.props.onOk();

    render() {
        const {size, cancelText, okText, autoHeight, confirmLoading, wrapClassName, ...restProps} = this.props;
        const [width, className] = modalSizeMap[size];
        const footer = (
            <div>
                <Button onClick={this.handleCancel}>{cancelText}</Button>
                <Button type="solid" onClick={this.handleOk} loading={confirmLoading}>{okText}</Button>
            </div>
        );

        return (
            <AntModal
                centered
                onOk={this.handleCancel}
                onCancel={this.handleOk}
                footer={footer}
                maskStyle={maskStyle}
                width={width}
                wrapClassName={classNames(
                    wrapClassName, styles.modal, styles[className], {[styles['auto-height']]: autoHeight}
                )}
                {...restProps}
            />
        );
    }
}

const getConfirmTitle = (title, type) => {
    const [Icon, defaultTitle] = infoTypeMap[type];

    return (
        <div className={cx('body-title')}>
            <span className={cx('icon', type)}>
                <Icon />
            </span>
            <span className={cx('title')}>
                {title || defaultTitle}
            </span>
        </div>
    );
};

const getConfirmConfig = (config, type) => ({
    className: classNames(styles.confirm, config.className),
    okText: '知道了',
    width: 400,
    keyboard: false,
    ...config,
    iconType: 'hide',
    title: getConfirmTitle(config.title, type)
});

reduce(
    (result, value) => {
        /* eslint-disable no-param-reassign */
        result[value] = config => AntModal[value](getConfirmConfig(config, value));
        /* eslint-enable  no-param-reassign */
        return result;
    },
    Modal,
    keys(infoTypeMap)
);

Modal.confirm = config => (
    AntModal.confirm({
        className: classNames(styles.confirm, config.className),
        okText: '确定',
        cancelText: '取消',
        width: 400,
        ...config,
        iconType: 'hide'
    })
);

Modal.propTypes = {
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    autoHeight: PropTypes.bool,
    cancelText: PropTypes.string,
    okText: PropTypes.string,
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    confirmLoading: PropTypes.bool,
    wrapClassName: PropTypes.string
};

Modal.defaultProps = {
    size: 'm',
    autoHeight: false,
    cancelText: '取消',
    okText: '确定',
    onCancel: noop,
    onOk: noop,
    confirmLoading: false,
    wrapClassName: ''
};

export default Modal;
